<template>
  <div class="add-ad-account">
    <div class="add-ad-account-container" ref="addAdAccountWrapper">
      <div class="add-ad-account-h">
        <div class="add-ad-account-title">
          <span class="text">{{ $t('Campaigns.AddAdAccount.Title') }}</span>
        </div>
        <div class="add-ad-account-close" @click="emitToggleAddAccount2">
          <icon-base width="16" height="16" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
        </div>
      </div>
      <div class="add-ad-account-b">
        <div class="add-ad-account-form">
          <div class="add-ad-account-field">
            <div class="dropdown-w" v-show="campaignsPageData && !campaignsPageData.CompanyId">
              <b-dropdown v-model="selectedCompany" scrollable aria-role="list" :disabled="!companies.length"
                    @active-change="onDropdownActiveChange" @input="onSelectedCompanyChange">
                <template #trigger>
                  <b-button>
                    <span class="dropdown-trigger-value">{{ selectedCompany ? selectedCompany.Title : $t("Campaigns.CompanyPlaceholder") }}</span>
                    <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                  </b-button>
                </template>
                <b-dropdown-item custom aria-role="listitem" class="filter-search">
                  <b-input v-model="companiesSearch" class="search" :placeholder="$t('Search')" expanded />
                </b-dropdown-item>
                <b-dropdown-item v-for="company in companiesFiltered" :key="company.Id" :value="company" aria-role="listitem">
                  <span>{{ company.Title }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="add-ad-account-field" v-if="selectedCompany">
            <b-field :label="$t('Campaigns.AddAdAccount.Kind')">
                <b-select expanded :placeholder="$t('Campaigns.AddAdAccount.Kind')" v-model="selectedAddAdAccountKind" @input="onAddAdAccountKindChange">
                    <option :value="AddAdAccountKind.Facebook" :key="AddAdAccountKind.Facebook">
                        {{ $t("Campaigns.AddAdAccount.Facebook.Title") }}
                    </option>
                    <option :value="AddAdAccountKind.Google" :key="AddAdAccountKind.Google">
                        {{ $t("Campaigns.AddAdAccount.Google.Title") }}
                    </option>
                    <option :value="AddAdAccountKind.Outbrain" :key="AddAdAccountKind.Outbrain">
                      {{ $t("Campaigns.AddAdAccount.Outbrain.Title") }}
                    </option>
                    <option :value="AddAdAccountKind.TikTok" :key="AddAdAccountKind.TikTok">
                      {{ $t("Campaigns.AddAdAccount.TikTok.Title") }}
                    </option>
                    <option :value="AddAdAccountKind.Linkedin" :key="AddAdAccountKind.Linkedin">
                      {{ $t("Campaigns.AddAdAccount.Linkedin.Title") }}
                    </option>
                </b-select>
            </b-field>
          </div>
          <div v-if="selectedAddAdAccountKind !== null && (facebookConnectData !== null || googleConnectData !== null || outbrainConnectData != null || tiktokConnectData != null  || linkedinConnectData != null)">
              <b-button type="is-link" expanded @click="connect">
                  {{
                  (() => {
                    switch (selectedAddAdAccountKind) {
                      case AddAdAccountKind.Facebook:
                        return facebookConnectData ? facebookConnectData.ButtonText : '';
                      case AddAdAccountKind.Google:
                        return googleConnectData ? googleConnectData.ButtonText : '';
                      case AddAdAccountKind.Outbrain:
                        return outbrainConnectData ? outbrainConnectData.ButtonText : '';
                      case AddAdAccountKind.TikTok:
                        return tiktokConnectData ? tiktokConnectData.ButtonText : '';
                      case AddAdAccountKind.Linkedin:
                        return linkedinConnectData ? linkedinConnectData.ButtonText : '';
                      default:
                        return '';
                    }
                  })()
                  }}
                  <span class="badges-container">
                      <span class="badge badge-info">beta</span>
                  </span>
              </b-button>
            <div v-if="!messageSent">
              <p class="message-to-programmer">
                {{ $t(`Campaigns.AddAdAccount.${AddAdAccountKind[selectedAddAdAccountKind]}.MessageToManager`) }}
              </p>
              <hr />
              <div class="add-ad-account-field">
                <b-field :label="selectedAddAdAccountKind === AddAdAccountKind.Facebook ?
                      $t('Campaigns.AddAdAccount.Facebook.ConnectEmail') : $t('Campaigns.AddAdAccount.Google.ConnectEmail')">
                  <b-input v-model="email" :placeholder="selectedAddAdAccountKind === AddAdAccountKind.Facebook ?
                        $t('Campaigns.AddAdAccount.Facebook.ConnectEmailPlaceholder') : $t('Campaigns.AddAdAccount.Google.ConnectEmailPlaceholder')"></b-input>
                </b-field>
              </div>
              <div class="add-ad-account-field">
                <b-field :label="selectedAddAdAccountKind === AddAdAccountKind.Facebook ?
                      $t('Campaigns.AddAdAccount.Facebook.ConnectMessage') : $t('Campaigns.AddAdAccount.Google.ConnectMessage')">
                  <b-input type="textarea" v-model="message"></b-input>
                </b-field>
              </div>
              <div class="buttons">
                <div class="button-w">
                  <b-button type="is-primary" expanded @click="send">{{ $t("Send") }}</b-button>
                </div>
                <div class="button-w">
                  <b-button type="" class="is-nobackground" expanded @click="emitToggleAddAccount2">{{ $t("Cancel") }}</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-ad-account-bg" @click="emitToggleAddAccount2"></div>
  </div>
</template>

<script lang="ts">
import IconBase from "@/components/IconBase.vue";
import IconCaretDown from "@/components/icons/IconCaretDown.vue";
import IconTimes from "@/components/icons/IconTimes.vue";
import i18n from "@/i18n";
import { CampaignsPageViewModel } from "@/models/campaigns/Campaign";
import { FacebookConnectData } from "@/models/FacebookConnectData";
import { GoogleConnectData } from "@/models/GoogleConnectData";
import { MultiselectItem } from "@/models/MultiselectItem";
import { OutbrainConnectData } from "@/models/OutbrainConnectData";
import { Result } from "@/models/Result";
import { TikTokConnectData } from "@/models/TikTokConnectData";
import { UserData } from "@/models/UserData";
import FacebookApiService from "@/services/api/FacebookApiService";
import GoogleApiService from "@/services/api/GoogleApiService";
import OutbrainApiService from "@/services/api/OutbrainApiService";
import TikTokApiService from "@/services/api/TikTokApiService";
import ConfigService from "@/services/ConfigService";
import HelperService from "@/services/HelperService";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {LinkedinConnectData} from "@/models/LinkedinConnectData";
import LinkedinApiService from "@/services/api/LinkedinApiService";

const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconTimes,
  },
})
export default class AddAdAccount extends Vue {
  emitToggleAddAccount2(): void {
    this.$emit("toggle-add-ad-account2");
  }

  //#region Vuex getters and actions

  @Getter("campaignsPageData", { namespace }) campaignsPageData!: CampaignsPageViewModel;
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("userData", { namespace: "mainModule" }) userData!: UserData;

  //#endregion Vuex getters and actions

  //#region Properties

  companiesSearch = "";
  email = "";
  message = "";
  messageSent = false;
  selectedAddAdAccountKind: AddAdAccountKind | null = null;
  facebookConnectData: FacebookConnectData | null = null;
  googleConnectData: GoogleConnectData | null = null;
  outbrainConnectData: OutbrainConnectData | null = null;
  tiktokConnectData: TikTokConnectData | null = null;
  linkedinConnectData: LinkedinConnectData | null = null;
  selectedCompany: MultiselectItem | null = null;

  AddAdAccountKind = AddAdAccountKind;

  //#endregion Properties

  //#region Watches

  @Watch("companies", { immediate: true })
  onClientsChange(newClients: MultiselectItem[], oldClients: MultiselectItem[]): void {
    if (this.campaignsPageData?.CompanyId && newClients?.length > 0) {
      const company = this.companies.find((i: MultiselectItem) => +i.Id === this.campaignsPageData.CompanyId);
      this.selectedCompany = company || null;
    }
  }

  //#endregion Watches

  //#region Getters

  get companiesFiltered(): MultiselectItem[] {
    return this.companies.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.companiesSearch.toLowerCase()) >= 0);
  }

  //#endregion Getters

  //#region Handlers

  connect(): void {
    if (this.selectedCompany === null) {
      return;
    }
    const loader = this.$loading.show({
      container: this.$refs.addAdAccountWrapper,
    });
    if (this.selectedAddAdAccountKind === AddAdAccountKind.Facebook) {
      FacebookApiService.loginCustomer(this.selectedCompany.Id as any as number).then((result: Result) => {
        if (result.Success) {
          if (this.selectedCompany !== null) {
            location.href = `${ConfigService.facebookPageUrl}?companyId=${this.selectedCompany.Id}`;
          }
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Google) {
      GoogleApiService.loginCustomer(this.selectedCompany.Id as any as number).then((result: Result) => {
        if (result.Success) {
          if (this.selectedCompany !== null) {
            location.href = `${ConfigService.googlePageUrl}?companyId=${this.selectedCompany.Id}`;
          }
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Outbrain) {
      OutbrainApiService.loginCustomer(this.selectedCompany.Id as any as number).then((result: Result) => {
        if (result.Success) {
          if (this.selectedCompany !== null) {
            location.href = `${ConfigService.outbrainPageUrl}?companyId=${this.selectedCompany.Id}`;
          }
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.TikTok) {
      TikTokApiService.loginCustomer(this.selectedCompany.Id as any as number).then((result: Result) => {
        if (result.Success) {
          if (this.selectedCompany !== null) {
            location.href = `${ConfigService.tiktokPageUrl}?companyId=${this.selectedCompany.Id}`;
          }
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Linkedin) {
      LinkedinApiService.loginCustomer(this.selectedCompany.Id as any as number).then((result: Result) => {
        if (result.Success) {
          if (this.selectedCompany !== null) {
            location.href = `${ConfigService.linkedinPageUrl}?companyId=${this.selectedCompany.Id}`;
          }
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
  }

  onSelectedCompanyChange() {
    this.selectedAddAdAccountKind = null;
  }

  onAddAdAccountKindChange() {
    let loader = this.$loading.show({
      container: this.$refs.addAdAccountWrapper
    });
    const companyId: number = this.selectedCompany ? this.selectedCompany.Id as any as number : 0;
    if (this.selectedAddAdAccountKind === AddAdAccountKind.Facebook) {
      FacebookApiService.getFacebookConnectData(companyId).then((result: Result) => {
        if (result.Success) {
          this.facebookConnectData = result.Data as FacebookConnectData;
          this.message = this.facebookConnectData.MsgToProgrammer;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    } else if (this.selectedAddAdAccountKind === AddAdAccountKind.Google) {
      GoogleApiService.getGoogleConnectData(companyId).then((result: Result) => {
        if (result.Success) {
          this.googleConnectData = result.Data as GoogleConnectData;
          this.message = this.googleConnectData.MsgToProgrammer;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Outbrain) {
      OutbrainApiService.getOutbrainConnectData(companyId).then((result: Result) => {
        if (result.Success) {
          this.outbrainConnectData = result.Data as OutbrainConnectData;
          this.message = this.outbrainConnectData.MsgToProgrammer;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.TikTok) {
      TikTokApiService.getTikTokConnectData(companyId).then((result: Result) => {
        if (result.Success) {
          this.tiktokConnectData = result.Data as TikTokConnectData;
          this.message = this.tiktokConnectData.MsgToProgrammer;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Linkedin) {
      LinkedinApiService.getLinkedinConnectData(companyId).then((result: Result) => {
        if (result.Success) {
          this.linkedinConnectData = result.Data as LinkedinConnectData;
          this.message = this.linkedinConnectData.MsgToProgrammer;
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  send() {
    if (!this.selectedCompany) {
      return;
    }
    if (!this.email) {
      HelperService.showError(i18n.t("EmailRequired").toString());
      return;
    }
    let loader = this.$loading.show({
      container: this.$refs.addAdAccountWrapper
    });
    if (this.selectedAddAdAccountKind === AddAdAccountKind.Facebook) {
      FacebookApiService.sendConnectMessage(this.email, this.selectedCompany.Title, this.message).then((result: Result) => {
        if (result.Success) {
          this.messageSent = true;
          HelperService.showMessage("", i18n.t("CampaignEdit.Google.MessageSent").toString());
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    } else if (this.selectedAddAdAccountKind === AddAdAccountKind.Google) {
      GoogleApiService.sendConnectMessage(this.email, this.selectedCompany.Title, this.message).then((result: Result) => {
        if (result.Success) {
          this.messageSent = true;
          HelperService.showMessage("", i18n.t("CampaignEdit.Google.MessageSent").toString());
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Outbrain) {
      OutbrainApiService.sendConnectMessage(this.email, this.selectedCompany.Title, this.message).then((result: Result) => {
        if (result.Success) {
          this.messageSent = true;
          HelperService.showMessage("", i18n.t("CampaignEdit.Outbrain.MessageSent").toString());
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.TikTok) {
      TikTokApiService.sendConnectMessage(this.email, this.selectedCompany.Title, this.message).then((result: Result) => {
        if (result.Success) {
          this.messageSent = true;
          HelperService.showMessage("", i18n.t("CampaignEdit.Google.MessageSent").toString());
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
    else if (this.selectedAddAdAccountKind === AddAdAccountKind.Linkedin) {
      LinkedinApiService.sendConnectMessage(this.email, this.selectedCompany.Title, this.message).then((result: Result) => {
        if (result.Success) {
          this.messageSent = true;
          HelperService.showMessage("", i18n.t("CampaignEdit.Google.MessageSent").toString());
        } else {
          HelperService.showError(result.Message);
        }
      }).finally(() => {
        loader.hide();
      });
    }
  }

  //#endregion Handlers
}

enum AddAdAccountKind {
  Facebook,
  Google,
  Outbrain,
  TikTok,
  Linkedin,
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.add-ad-account {
  position: fixed;
  z-index: 101;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;

  .add-ad-account-container {
    position: fixed;
    top: 0;
    right: 0;
    width: 477px;
    height: 100%;
    max-height: 100%;
    z-index: 10;
    transition: all 0.5s;
    transform: translateX(0);
    background: #f6f7fb;

    @media (max-width: 991px) {
      height: 100%;
    }

    @media (max-width: 575px) {
      width: 100%;
    }
  }

  .add-ad-account-h {
    position: fixed;
    top: 0;
    left: 0;
    height: 56px;
    width: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 12px 15px 13px 10px;
    background: linear-gradient(90deg, $primary 0%, #1ca8d9 52.75%);

    .add-ad-account-close {
      padding: 5px;
      cursor: pointer;
      line-height: 0;
      margin: 0 0 0 auto;
      transition: all 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }

    .add-ad-account-title {
      display: flex;
      align-items: center;
      font-size: 21px;
      .icon-w {
        margin-left: 10px;
      }
    }
  }

  .add-ad-account-b {
    position: fixed;
    top: 56px;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 22px 37px 40px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    @media (max-width: 575px) {
      padding: 10px 15px 30px;
    }

    hr {
      border-bottom: 1px solid #e0e2eb;
      grid-column: 1 / 3;
      margin: 0 0 1rem;
    }

    .textarea {
      height: 15rem;
    }

    .dropdown {
      width: 100%;
      .dropdown-trigger {
        .button {
          width: 100%;
        }
      }
    }
    
    .buttons {
      margin: auto -10px 0;
      display: flex;
      padding: 0;
      @media (max-width: 575px) {
        margin: auto -8px 0;
      }
      .button-w {
        width: 50%;
        flex: 0 0 50%;
        padding: 0 10px;
        @media (max-width: 575px) {
          padding: 0 8px;
        }
      }
      .button {
        margin: 0;
        min-width: 0;
      }
    }

    .add-ad-account-form {
      .add-ad-account-field {
        margin-bottom: 1rem;

        &.full-width-field {
          grid-column: 1 / 3;
        }

        input[disabled], select[disabled], textarea[disabled] {
          background: #eff0f6;
        }
      }

      .message-to-programmer {
        font-weight: bold;
        margin: 1rem 0;  
      }
    }
  }
  .add-ad-account-bg {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    transition: all 0.5s;
    background: rgba(0, 0, 0, 0.3);
  }
  .buttons {
    padding-bottom: 30px;
    .button {
      margin: 0;
    }
  }

  &.fade-enter-active,
  &.fade-leave-active {
    z-index: 101;
    transition: all 0.5s;
  }
  &.fade-enter,
  &.fade-leave-to,
  &.fade-leave-active {
    opacity: 1;
    .add-ad-account-container {
      transform: translateX(100%);
    }
    .add-ad-account-bg {
      opacity: 0;
    }
  }
}

html[dir="rtl"] {
  .add-ad-account {

    .add-ad-account-h {
      padding: 12px 15px 13px 10px;

      .add-ad-account-close {
        margin: 0 auto 0 0;
      }
    }
  }
}

@media (resolution: 120dpi) {
  .add-ad-account .add-ad-account-container {
    height: 125%;
    max-height: 125%;
  }
  .add-ad-account .add-ad-account-bg {
    height: 125%;
  }
}
</style>
